<template>
  <v-container
    id="movimentacaoContas"
  >
    <div>
      <v-row v-if="loading">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            :style="styleObject"
            class="text-center"
          >
            <v-icon
              light
              class="custom-loader"
              :style="styleObject"
            >
              mdi-cached
            </v-icon>
            Carregando dados...
          </div>
        </v-col>
      </v-row>
      <v-row v-else-if="error">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            class="alert alert-danger"
          >
            {{ error }}
          </div>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <v-data-table
            id="headersMovimentacao"
            :headers="headersProjecaoContasBancarias"
            :items="projecaoContasBancarias"
            :items-per-page="projecaoContasBancarias.length"
            hide-default-footer
            disable-sort
            class="elevation-1"
            style="color: black"
          >
            <template v-slot:[`item.desc_conta`]="{ item }">
              <td
                id="formaterDados"
              >
                {{ item.desc_conta }}
              </td>
            </template>
            <template v-slot:[`item.data1`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data1 }}
              </td>
            </template>
            <template v-slot:[`item.data2`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data2 }}
              </td>
            </template>
            <template v-slot:[`item.data3`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data3 }}
              </td>
            </template>
            <template v-slot:[`item.data4`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data4 }}
              </td>
            </template>
            <template v-slot:[`item.data5`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data5 }}
              </td>
            </template>
            <template v-slot:[`item.data6`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data6 }}
              </td>
            </template>
            <template v-slot:[`item.data7`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data7 }}
              </td>
            </template>
            <template v-slot:[`item.saldo`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.saldo }}
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import FluxoCaixa from '../../../../../services/fluxocaixa'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowSaldoTotal',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: '#4CAF50',
      },
      styleSaldoBancario: {
        color: '#4CAF50',
      },
      loading: false,
      error: null,
      select: [],
      headersProjecaoContasBancarias: [],
      projecaoContasBancarias: [],
    }),

    created () {
      eventEmit.$on('update-fluxo', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-fluxo', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (select) {
        this.select = select

        this.showDadosMovimentacaoContas()
      },

      async showDadosMovimentacaoContas () {
        this.loading = true

        this.projecaoContasBancarias = []

        await FluxoCaixa.showMovimentacaoContas(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.headersProjecaoContasBancarias = resposta.data.headers

            const setPerson = new Set()

            const filterConta = resposta.data.dadosMovimentacao.filter((person) => {
              const duplicatedPerson = setPerson.has(person.desc_conta)
              setPerson.add(person.desc_conta)
              return !duplicatedPerson
            })

            var total1 = 0
            var total2 = 0
            var total3 = 0
            var total4 = 0
            var total5 = 0
            var total6 = 0
            var total7 = 0
            var total8 = 0

            for (let i = 0; i < filterConta.length; i++) {
              total1 += filterConta[i].data1
              total2 += filterConta[i].data2
              total3 += filterConta[i].data3
              total4 += filterConta[i].data4
              total5 += filterConta[i].data5
              total6 += filterConta[i].data6
              total7 += filterConta[i].data7
              total8 += filterConta[i].saldo
            }

            const total = {
              desc_conta: '',
              data1: total1,
              data2: total2,
              data3: total3,
              data4: total4,
              data5: total5,
              data6: total6,
              data7: total7,
              saldo: total8,
            }

            filterConta.push(total)

            this.projecaoContasBancarias = filterConta.map((item) => {
              var listaMovimentacao = ({
                desc_conta: item.desc_conta,
                data1: parseFloat(item.data1).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data2: parseFloat(item.data2).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data3: parseFloat(item.data3).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data4: parseFloat(item.data4).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data5: parseFloat(item.data5).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data6: parseFloat(item.data6).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data7: parseFloat(item.data7).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                saldo: parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaMovimentacao
            })
          } else if (resposta.data.text === 'Não há dados de saldo bancário') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há dados de contas a receber') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #movimentacaoContas {
    max-width: 100%
  }

  #formaterDados {
    font-size: 11px
  }
</style>
